export default __webpack_public_path__ + "static/media/9.9f83b3a6.jpg";